import { Icon } from '@sr/ui-library';
import { passwordChecksFor } from '../../../../utils/auth/passwordPolicy';

export interface PasswordRuleChecklistProps {
  'aria-label'?: string;
  className?: string;
  password: string;
}

export const PasswordRuleChecklist = ({
  'aria-label': ariaLabel = 'Password requirements',
  className,
  password,
}: PasswordRuleChecklistProps) => {
  const checks = passwordChecksFor(password);

  return (
    <>
      <ul
        aria-label={ariaLabel}
        className={className ?? '-mt-2 flex flex-col gap-1 text-sm'}
      >
        {checks.map((rule) => (
          <li
            key={rule.id}
            className={`flex items-center gap-2 ${
              rule.met ? 'text-sr-text-success' : 'text-sr-text-secondary'
            }`}
          >
            <Icon
              aria-hidden
              className={rule.met ? '' : 'opacity-40'}
              icon={rule.met ? 'success' : 'check'}
              size="xs"
            />
            <span>{rule.label}</span>
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-sr-text-secondary">
        Avoid common or previously breached passwords. They may be rejected.
      </p>
    </>
  );
};
